import React, { Component } from "react";
// import { Route, Switch } from "react-router-dom";
// Navigation
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";

// import Login from "../../views/Login/Login";
// import Signup from "../../views/Signup/Signup";
// Auth Users
// import Dashboard from "../../views/Dashboard/Dashboard";
// import Locklist from "../../views/Locklist/Locklist";
// import ShareHistory from "../../views/ShareHistory/index";
// import AuditTrail from "../../views/AuditTrail/AuditTrail";
// import AccountManagement from "../../views/AccountManagement/AccountManagement";
// import GroupManagement from "../../views/GroupManagement/GroupManagement";
// import GrantAccess from "../../views/GrantAccess/GrantAccess";
// import GroupShare from "../../views/GroupSharing/index";
// import RecipientManagement from "../../views/RecipientManagement/index";
// import RetractableAccess from "../../views/RetractableAccess/retractable";
// import PageNotFound from "../../views/Errors/404Error";
// import SimpleMap from "../../views/AuditTrailMapview/MapView";
// import Plans from "../../views/Plans/Plans";

import Chatbot from "../../views/Chatbot/Chatbot";
// routes
import "../../routes/app";

//HttpsRedirect
import HttpsRedirect from "react-https-redirect";

//Authentication
import withAuth from "../../components/Auth/withAuth";
import AuthUserContext from "../../components/Auth/AuthUserContext";

import SuperAdminRoutes from "./SuperAdminRoutes";
import LoginAndSignUpRoute from "./LoginAndSignUpRoute";
import AdminRoutes from "./AdminRoutes";
import MemberRoutes from "./MemberRoutes";
import NewUserRoutes from "./NewUserRoutes";
import { customLog } from "../../variables/Variables";

// import { auth } from "firebase";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authUser: null,
      memberRole: null,
    };

    this.checkAndEnableLink = this.checkAndEnableLink.bind(this);
    // this.sendAuthToSidebar = this.sendAuthToSidebar.bind(this);
  }
  // DONT UNCOMMENT THIS. THIS RESPONSIVE CODE IS NOT WORKING WHEN SWITCH TO OTHER PAGES
  // BUT CAN REFER WHEN NEED TO
  // componentDidUpdate(e) {
  //     if (window.innerWidth < 993 && e.history.location.pathname !== e.location.pathname && document.documentElement.className.indexOf('nav-open') !== -1) {
  //         document.documentElement.classList.toggle('nav-open');
  //     }
  // }

  checkAndEnableLink() {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => {
          if (authUser) {
            if (authUser.isPaymentValid) {
              if (authUser.isSuperAdmin) {
                customLog("Here super admin");
                return <SuperAdminRoutes />;
              } else if (authUser.isAdmin) {
                return <AdminRoutes />;
              } else {
                return <MemberRoutes />;
              }
            } else if (authUser.notPartOfMember) {
              return <NewUserRoutes />;
            }
          } else {
            return <LoginAndSignUpRoute />;
          }
        }}
      </AuthUserContext.Consumer>
    );
  }


  render() {
    return (
      <div>
        <HttpsRedirect>
          <div className="wrapper">
            <Sidebar {...this.props} />
            <div id="main-panel" className="main-panel">
              <Header {...this.props} />
              <div className="main-panel__content">
                {this.checkAndEnableLink()}
              </div>    
            </div>
          </div>
          {/* <Footer /> */}
        </HttpsRedirect>


  

      </div>
      );
  }
}

//test
export default withAuth(App);
